import React, { useEffect, useState } from 'react';
import '../css/hero.css';
import hero from '../assets/images/logos/logo_final_sim_fondo.svg';

const Hero = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const hideTimer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(hideTimer);
  }, []);

  if (!visible) return null;

  return (
    <section className="hero">
      <img src={hero} alt="Logo home" className="hero-img" />
    </section>
  );
};

export default Hero;
